import React, { useState } from 'react';
import { RequiredFieldNotice } from '../basic/RequiredFieldNotice';
import { FormHeader } from '../basic/FormHeader';
import { trackingClient, useTrackLoadUnload } from '../../ext/tracking';
import { EnterAwareButton } from '../magma-wrap/EnterAwareButton';
import { Marker } from '../meta/Marker';
import { InstitutionPicker } from '../screens/Profile/institution/InstitutionPicker';
import { HasInCommon } from '../../api';
import { Option } from '../magma-wrap/shared';

export const TEST_ID = {
  MARKER: 'marker-school-search',
  BUTTON_SUBMIT: 'button-submit'
};

export interface StudentSchoolSearchProps {}
export interface InCommonSchoolData {
  sawsEntityId: string;
}

export const StudentSchoolSearch: React.FC<StudentSchoolSearchProps> = () => {
  const [inCommonSchool, setInCommonSchool] = useState<null | Option>(null);
  const [isDisabled, setIsDisabled] = useState(true);

  const category = trackingClient.event.discovery;
  useTrackLoadUnload(category);

  // Can't reasonably unit test location changes, relying on type safety
  /* istanbul ignore next */
  const initiateSchoolLogin = () => {
    if (inCommonSchool?.item) {
      const schoolData: InCommonSchoolData = JSON.parse(
        inCommonSchool?.item as string
      );
      (document.location as any) = '/oidc/register/satosa?sawsEntityId=' + encodeURIComponent(schoolData.sawsEntityId);
    }
  };

  return (
    <>
      <Marker testId={TEST_ID.MARKER} />

      <FormHeader>Search Schools</FormHeader>
      <RequiredFieldNotice />
      <InstitutionPicker
        hasInCommon={HasInCommon.true}
        onChange={(option: Option) => {
          setInCommonSchool(option);
          setIsDisabled(!option);
        }}
      />

      <EnterAwareButton
        style={{ minWidth: '300px' }}
        isFullWidth={true}
        testId={TEST_ID.BUTTON_SUBMIT}
        id="submit-button"
        value="Next"
        disabled={isDisabled}
        onClick={initiateSchoolLogin}
      />
    </>
  );
};